"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.groupForm.title': 'Aggiungi gruppo WhatsApp',
    'whatsapp.groupForm.back': 'Indietro',
    'whatsapp.groupForm.cancel': 'Annulla',
    'whatsapp.groupForm.save': 'Salva',
    'whatsapp.groupForm.name': 'Nome gruppo',
    'whatsapp.groupForm.namePlaceholder': 'Inserire nome gruppo...',
    'whatsapp.groupForm.pinMessage': 'Messaggio fissato',
    'whatsapp.groupForm.pinMessagePlaceholder': 'Contenuto del messaggio da fissare nel gruppo...',
    'whatsapp.groupForm.pinMessageHint': 'Se il monitoraggio è attivo e il bot è amministratore, questo messaggio verrà fissato.',
    'whatsapp.groupForm.nameRequired': 'Il nome del gruppo è obbligatorio.',
    'whatsapp.groupForm.avatar': 'Avatar',
    'whatsapp.groupForm.selectAvatar': '-- Seleziona avatar --',
    'whatsapp.groupForm.botInstruction': 'Istruzione bot',
    'whatsapp.groupForm.botInstructionPlaceholder': 'Inserire istruzioni per il bot WhatsApp...',
    'whatsapp.groupForm.invitePhones': 'Numeri di telefono da invitare',
    'whatsapp.groupForm.phonePlaceholder': 'Inserire numero di telefono...',
    'whatsapp.groupForm.addPhone': 'Aggiungi telefono',
    'whatsapp.groupForm.noPhonesYet': 'Nessun numero di telefono aggiunto ancora.',
    'whatsapp.groupForm.createSuccess': 'Gruppo creato con successo.',
    'whatsapp.groupForm.createFailed': 'Impossibile creare il gruppo.',
};
